import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.75 3a.75.75 0 0 0-1.5 0v1h-6.5V3a.75.75 0 0 0-1.5 0v1H4.222C2.995 4 2 4.895 2 6v14c0 1.105.995 2 2.222 2h15.556C21.005 22 22 21.105 22 20V6c0-1.105-.995-2-2.222-2H16.75zm-9.5 3v-.5H4.222a.85.85 0 0 0-.568.2c-.12.109-.154.216-.154.3v4.25h17V6c0-.084-.034-.191-.154-.3a.85.85 0 0 0-.568-.2H16.75V6a.75.75 0 0 1-1.5 0v-.5h-6.5V6a.75.75 0 0 1-1.5 0m13.25 5.75h-17V20c0 .084.034.191.154.3.123.11.32.2.568.2h15.556c.249 0 .445-.09.568-.2.12-.109.154-.216.154-.3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }